import styleAnswer from "./qustions.module.css";
import {ReturnTextAndImg} from "../../test/CheckImg";
import React from "react";
const styleTable = {str:{display:'flex'},element:{width:'90px',border:'1px solid black',overflowWrap: 'break-word'}}

export const rightAnswer =(question)=> {
    if (!question) {
        return null
    }
    if (question.type === 1 || question.type===4 || question.type===2) {
        const right = question.right_answers.filter(item => Number(item.percent) > 0);
        const parameter = question.right_answers[0]?.parameter;
        return (<div>
            {parameter?.isAllCheck && <p className={styleAnswer.parameter}>Должны быть выбраны все правильные ответы</p>}
            {right.map((item,i) =>
                <div key={item.name} className={styleAnswer.rightAnswer}>{i+1}) {ReturnTextAndImg(item.name)} {!parameter?.isAllCheck && `- ${item.percent}%`}</div>
            )}
        </div>)
    }

    if (question.type === 3 || question.type === 8) {
        return <p>Проверялось экспертом</p>
    }
    if(question.type===5){
        return <div>
            {question.right_answers.map((item,i)=>
                <div key={i} className={styleAnswer.rightAnswer}>{ReturnTextAndImg(item.name)} - {ReturnTextAndImg(item.equal)}</div>
            )}
        </div>
    }
    if(question.type===6){
        const right = question.right_answers.filter((item,i)=>i%2===1)
        return right.map((item,i)=><p key={i}>{i+1}) {item}</p>)
    }
    if(question.type===7){
        return <div>
            {question.right_answers.map((item, i) =>
                <div key={i} className={styleAnswer.rightAnswer}>{ReturnTextAndImg(item)}</div>
            )}
        </div>
    }
    if (question.type === 9) {
        const answer = question.right_answers;

        const rightStr = answer.map((item, index) => {
            return index % 2 === 1 ? `[![/${item}/]!]` : item;
        }).join(' ');

        return (
            <div>
                {ReturnTextAndImg(rightStr)}
            </div>
        );
    }
    if(question.type===10){
        const answer =question.right_answers
        return (<div>
            {answer.map((str,i)=><div key={i} style={styleTable.str}>
                {str.map((item,count)=> {
                    if(count === 0 && i ===0 ){
                        return <div style={styleTable.element} key={`${count}${i}`}>Таблица</div>
                    }
                    else if(item === '') {
                        return <div style={styleTable.element}  key={`${count}${i}`}>x</div>
                    }
                    else if(item === true){
                        return <div style={styleTable.element}  key={`${count}${i}`}>o</div>
                    }
                    else{
                        return <div style={styleTable.element}  key={`${count}${i}`}>{item.text}</div>
                    }
                })}
            </div>)}
        </div>)
    }
    if(question.type===11){
        const answer = [...question.right_answers]
        const parameter = answer.pop();
        const right = answer.filter(item => Number(item.percent) > 0)
        return <div>
            {right.map((item,i)=><div className={styleAnswer.rightAnswer} key={i}>{ReturnTextAndImg(item.name)}</div>)}
            <div>Текстовый ответ: {parameter.text}</div>
        </div>
    }
}